import Bounce from 'react-reveal/Bounce';

export const Services = (props) => {
  return (
    <div id='services' className='text-center'>
      <div className='container'>
        <Bounce bottom duration={2000}>
        <div className='section-title'>
          <h2>Kegiatan</h2>
          <p>
            Kegiatan berupa ekstrakurikuler.
          </p>
        </div>
        </Bounce>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4'>
                  {' '}
                <Bounce right duration={1500}> 
                  <i className={d.icon}></i>
                  <div className='service-desc'>
                    <h3>{d.name}</h3>
                    {/* <p>{d.text}</p> */}
                  </div>
                </Bounce>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
